window.addEventListener("load", function () {
    let modalAvisoPrivacidad = document.getElementById("modalAvisoPrivacidad");

    if (modalAvisoPrivacidad) {
        modalAvisoPrivacidad = new bootstrap.Modal(modalAvisoPrivacidad, {
            keyboard: false,
        });

        const avisoprivacidad = readCookie("avisoprivacidad");

        if (!avisoprivacidad || avisoprivacidad != "true") {
            modalAvisoPrivacidad.show();
        }
    }

    aceptoAviso = function (event) {
        document.cookie = "avisoprivacidad=true; max-age=3600; path=/";
    };

    modalInformativo = function () {
        let modalInformativoHistorico = document.getElementById(
            "modalInformativoHistorico"
        );

        if (modalInformativoHistorico) {
            modalInformativoHistorico = new bootstrap.Modal(
                modalInformativoHistorico,
                {
                    keyboard: false,
                }
            );

            const informativohistorico = readCookie("informativohistorico");

            if (!informativohistorico || informativohistorico != "true") {
                modalInformativoHistorico.show();
            }

            document.cookie = "informativohistorico=true; max-age=3600; path=/";
        }
    };

    function readCookie(name) {
        return (
            decodeURIComponent(
                document.cookie.replace(
                    new RegExp(
                        "(?:(?:^|.*;)\\s*" +
                            name.replace(/[\-\.\+\*]/g, "\\$&") +
                            "\\s*\\=\\s*([^;]*).*$)|^.*$"
                    ),
                    "$1"
                )
            ) || null
        );
    }
});

const mostrarLoginAccion = document.getElementById("mostrarLoginForm");
if (mostrarLoginAccion) {
    mostrarLoginAccion.addEventListener("click", function (event) {
        event.preventDefault();

        const loginForm = document.getElementById("loginForm");

        if (isHidden(loginForm)) {
            console.log("hidden");
            loginForm.setAttribute("style", "display:block;");
        } else {
            console.log("visible");
            loginForm.setAttribute("style", "display:none;");
        }
    });
}

function isHidden(el) {
    const style = window.getComputedStyle(el);
    return style.display === "none";
}

const cerrarLogin = document.getElementById("cerrarLogin");
if (cerrarLogin) {
    cerrarLogin.addEventListener("click", function (event) {
        event.preventDefault();

        const loginForm = document.getElementById("loginForm");
        loginForm.setAttribute("style", "display:none;");
    });
}
